import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import 'semantic-ui-css/semantic.min.css';
import './index.css';

import ScrollToTop from './ScrollToTop';
import Header from './Header';
import Footer from './Footer';
import LandingPage from './LandingPage';

import getStringsFromContentful from './getStringsFromContentful';

getStringsFromContentful
  .then(data => {
    ReactDOM.render(
      <Router>
        <ScrollToTop>
          <div>
            <Header />
            <Route
              exact
              path="/"
              render={props => <LandingPage {...props} strings={data.fields} />}
            />
            <Footer />
          </div>
        </ScrollToTop>
      </Router>,
      document.getElementById('root')
    );
  })
  .catch(error => {
    ReactDOM.render(
      <div style={{ textAlign: 'center' }}>
        <h1>Feil!</h1>
        <p>Klarte ikke laste inn siden. Prøv å laste den inn på nytt.</p>
      </div>,
      document.getElementById('root')
    );

    console.log(error);
  });



// WEBPACK FOOTER //
// ./src/index.js